var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('van-empty',{attrs:{"image":"error","description":"无效的数据"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }